const planIconMap = {
  '5_2_1_1': '/static/images/my-order/icon30day.png',
  '5_2_2_1': '/static/images/my-order/icon30day.png',
  '5_2_1_2': '/static/images/my-order/icon30day.png',
  '5_2_2_2': '/static/images/my-order/icon30day.png',
  '5_2_1_100': '/static/images/my-order/icon30day.png',
  '5_2_2_100': '/static/images/my-order/icon30day.png',

  '5_3_1_1': '/static/images/my-order/icon60day.png',
  '5_3_2_1': '/static/images/my-order/icon60day.png',
  '5_3_1_2': '/static/images/my-order/icon60day.png',
  '5_3_2_2': '/static/images/my-order/icon60day.png',
  '5_3_1_100': '/static/images/my-order/icon60day.png',
  '5_3_2_100': '/static/images/my-order/icon60day.png',

  '6_3_1_1': '/static/images/my-order/icon24／7.png',
  '6_3_2_1': '/static/images/my-order/icon24／7.png',
  '6_3_1_2': '/static/images/my-order/icon24／7.png',
  '6_3_2_2': '/static/images/my-order/icon24／7.png',
  '6_3_1_100': '/static/images/my-order/icon24／7.png',
  '6_3_2_100': '/static/images/my-order/icon24／7.png',
}

export default planIconMap;



// WEBPACK FOOTER //
// ./src/utils/planIconMap/index.js